<div class="assoc-wrap">
  <ng-container *ngFor="let i of visiveis">
    <nz-tag
      nz-tooltip
      [nzTooltipTitle]="tooltip(i)"
      [nzColor]="isDefault(i) ? 'default' : 'processing'"  
      class="assoc-tag"
    >
      <strong class="ent">{{ i.entidade }}</strong>
      <ng-container *ngIf="i.subtipo as st">
        <span class="sep">·</span><span class="sub">{{ st }}</span>
      </ng-container>
    </nz-tag>
  </ng-container>

  <button *ngIf="restantes > 0"
          type="button"
          class="assoc-more"
          (click)="toggle()"
          [nz-tooltip]
          [nzTooltipTitle]="expandido ? 'Mostrar menos' : ('+' + restantes + ' itens')">
    <nz-tag nzColor="default" class="assoc-tag more">
      {{ expandido ? 'mostrar menos' : ('+' + restantes) }}
    </nz-tag>
  </button>
</div>
